import { useSearchParams } from "react-router-dom";
import { getReleases } from "../data";
import { getShorts } from "../shorts/shortdata";
import '../App.css';

export default function ShortReader() {

    const [searchParams,] = useSearchParams();
    const target = searchParams.get("target")
    const releases = getReleases()
    const shorts = getShorts()
    let name = ""
    let shortData = ""

    if (target) {
        for (const group of releases) {
            for (const release of group.items) {
                if (release.index === target) {
                    name = release.name
                    break
                }
            }
        }
        if (shorts[target]) {
            shortData = shorts[target]
        }
    }

    document.title = name + " (Short)"

    return (
        <div>
            <div className="shortReader">
                <div className="shortReaderTitle">
                    {name}
                </div>
                {shortData}
            </div>
        </div>
    );
}